import { useContext } from 'react'

import { Toggle } from '@/components/ui'
import { formatDate, formatPrice } from '@/utils/formatters'
import BienContext from '@/features/biens/BienContext'
import DataContainer from '../../common/DataContainer'
import TodoListeArrivee from './TodoListeArrivee'
import DetailsLogement from './DetailsLogement'
import Entretiens from './Entretiens'
import Interventions from './Interventions'
import Activities from '../../common/Activities'

const LocationPasCommencee = () => {
  const { bien } = useContext(BienContext)
  const location = bien?.location 

  return (
    <div className="space-y-6">
      {/* Section principale avec deux colonnes */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        
        {/* Colonne gauche - Détails du logement */}
        <DetailsLogement bien={bien} />

        {/* Colonne droite - Votre arrivée dans le logement */}
        <div className='overflow-hidden h-full'>
          <h3 className="text-md font-semibold mb-2">Votre arrivée dans le logement</h3>
          <div className="w-full bg-primary-100 p-4 rounded-none space-y-4 h-full">
            <div className="flex flex-col gap-4">
              <div className="flex flex-wrap items-center space-x-6 space-y-2"> 
                <DataContainer label="Prorata 1er loyer" value={formatPrice(location?.montant_premier_loyer_prorata)} />
                <Toggle.Display label="Reçu" value={location?.premier_loyer_recu} />
              </div>

              <div className="flex flex-wrap items-center space-x-6 space-y-2"> 
                <DataContainer label="Frais d'entrée" value={formatPrice(location?.montant_frais_entree)} />
                <Toggle.Display label="Reçu" value={location?.frais_entree_recu} />
              </div>

              <div className="flex flex-wrap items-center space-x-6 space-y-2"> 
                <DataContainer label="Dépôt de garantie" value={formatPrice(location?.montant_depot_garantie)} />
                <Toggle.Display label="Reçu" value={location?.depot_garantie_recu} />
              </div>

              <DataContainer
                label="Date d'état des lieux"
                value={formatDate(location?.date_etat_lieux_entree)}
              />

              <DataContainer
                label="Date d'effet du bail"
                value={formatDate(location?.date_effet_bail)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* To Do List */}
      <TodoListeArrivee />

      {/* Historique des interventions et entretiens */}
      {/* <HistoriqueInterventionsEntretiens /> */}
      {/* Historique des entretiens */}
      <Entretiens />

      {/* Historique des interventions */}
      <Interventions />

      {/* Historique des activités */}
      <Activities />
    </div>
  )
}

export default LocationPasCommencee